<template>
    <li @click="sendTorosClickEvent">
        <div class="hotview_wrap">
            <a class="thumb_hotview" :class="CAT" :href="linkUrl">
                <img :src="thumbnailUrl" :alt="altMessage" class="img_thumb"/>
                <span class="wrap_txt" v-if="!hasImage">
                    <span class="inner_txt">
                        <span class="txt_thumb">
                            <span class="txt_cont">{{ article.content }}</span>
                        </span>
                    </span>
                </span>
            </a>
            <span class="detail_hotview">
                <a class="desc_hotview" :class="CAT" :href="linkUrl">{{ title }}</a>
                <a class="cmt_empty" :class="CAT" :href="linkUrl">댓글 <span class="num_placeholder">{{ article.commentCount }}</span></a>
            </span>
        </div>
    </li>
</template>

<script>
import axios from 'axios';
import { getThumbnailUrl } from '@src/utils';

export default {
    props: {
        config: Object,
        article: Object
    },
    data() {
        return {
            DEFAULT_IMG_URL: '//m1.daumcdn.net/cafeimg/mobile/bg_hotview_160201.png'
        }
    },
    computed: {
        svcParam() {
            return this.config.svcParam;
        },
        hasImage() {
            return !!this.article.image;
        },
        baseUrl() {
            return `/${this.article.grpcode}/${this.article.fldid}/${this.article.dataid}`;
        },
        linkUrl() {
            let url = `${this.baseUrl}?svc=${this.svcParam}`;
            if (this.article.bucket) {
                url += `&bucket=${this.article.bucket}`;
            }
            return url;
        },
        thumbnailUrl() {
            if (this.hasImage) {
                return `${getThumbnailUrl(this.article.image, 450, 280, 'S')}&scode=cafe`;
            }
            return this.DEFAULT_IMG_URL;
        },
        title() {
            return this.article.name.replace(/\\"/g, '"');
        },
        altMessage() {
            if (this.hasImage) {
                return '썸네일 이미지';
            }
            return '';
        },
        CAT() {
            return `?c_id=${encodeURIComponent(this.baseUrl)}&c_source=${this.article.grpcode}&c_ch=${this.svcParam}&c_title=${encodeURIComponent(this.title)}`;
        }
    },
    methods: {
        sendTorosClickEvent() {
            const data = {
                svc: this.svcParam,
                bucket: this.article.bucket,
                source: location.pathname,
                to: `/${this.article.grpcode}/${this.article.fldid}/${this.article.dataid}`
            };

            axios.post('/toros/usage/event/click', data, {
                headers: { 'content-type': 'application/json; charset=utf-8' },
            });
        }
    }
}
</script>
